var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-container will-transform"},[_c('div',{staticClass:"footer-group"},_vm._l((_vm.items),function(item){return _c('router-link',{key:item.url,staticClass:"light",attrs:{"tag":"p","to":item.url},domProps:{"innerHTML":_vm._s(item.title)}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c33c9e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/siteFooter.vue
// module id = null
// module chunks = 